import type { FeatureContext } from './featureContext';

/**
 * Player emotes (ADR-0144 / ADR-0387): the bow / salute / dance keybinding actions.
 * A toggle-style
 * `down` fires the gesture once (no hold semantics). Each sends an `Emote` client
 * command the server validates and rebroadcasts as an `ActionAnimation`, so the
 * gesture plays on this player's sprite for every client in the room (the
 * RollDice/stomp broadcast path), not just locally. A spammed emote is bounded by
 * the server's per-player cooldown; there is no client state to desync (the
 * animation is ephemeral, off the snapshot stream).
 *
 * Dance is temporarily admin-only. The reveal-only Welcome flag prevents an ordinary
 * client from sending the action accidentally, while the server re-authorizes the
 * passcode-proven account for both this hotkey and the `*dances*` chat trigger.
 */
export function installEmotes(ctx: FeatureContext): void {
  for (const emote of ['bow', 'salute'] as const) {
    ctx.actions.register(emote, {
      down: () => {
        const playerId = ctx.playerId();
        if (playerId !== undefined) {
          ctx.client()?.sendCommand({ kind: 'Emote', entity: playerId, emote });
        }
      },
    });
  }

  ctx.actions.register('dances', {
    down: () => {
      if (!ctx.state.isAdminViewer()) return;
      const playerId = ctx.playerId();
      if (playerId !== undefined) {
        ctx.client()?.sendCommand({ kind: 'Emote', entity: playerId, emote: 'dances' });
      }
    },
  });
}
